import React from "react";

const NotificationBanner = ({ message, onClose, errorResponse }) => {
    const isError = !!errorResponse;
    // Ako je errorResponse string, koristi ga; inače fallback na message
    const displayMessage = typeof errorResponse === 'string' ? errorResponse : message;

    return (
        <div className={`fixed top-4 flex items-center justify-between rounded-full w-auto ${isError ? "bg-red-500 text-white" : "bg-green-200 text-green-900"} px-7 py-2 md:shadow-lg z-50 animate-slide-in`}>
            <span className="">{displayMessage}</span>
            <button onClick={onClose} className="ml-4 font-bold">×</button>
        </div>
    );
};

export default NotificationBanner;
